module.exports = __webpack_public_path__ + "img/ic-scale-up.7545ac55.svg";